// extracted by mini-css-extract-plugin
module.exports = {"signin":"Signin_signin__14ir5","googleBtn":"Signin_googleBtn__1epcS","signInPrompt":"Signin_signInPrompt__1hm6S"};